import script from "./AssistentsIntegration.vue?vue&type=script&setup=true&lang=js"
export * from "./AssistentsIntegration.vue?vue&type=script&setup=true&lang=js"

import "./AssistentsIntegration.vue?vue&type=style&index=0&id=6e3b1b5e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e3b1b5e"]])

export default __exports__